// Deterministic colour combos for initial-only avatars. A person's id
// (numeric or string) is hashed and mapped to one of the 20 entries below,
// so the same user always lands on the same combo. Class strings are kept
// as literals so Tailwind's source scanner picks them up.
//
// `fill` colours the fallback bubble (bg + text). `ring` overrides the
// Avatar's default `after:border-border` so the outline matches the fill.

const PALETTE = [
  { fill: "bg-red-100 text-red-700",         ring: "after:border-red-700/20" },
  { fill: "bg-orange-100 text-orange-700",   ring: "after:border-orange-700/20" },
  { fill: "bg-amber-100 text-amber-800",     ring: "after:border-amber-800/20" },
  { fill: "bg-yellow-100 text-yellow-800",   ring: "after:border-yellow-800/20" },
  { fill: "bg-lime-100 text-lime-800",       ring: "after:border-lime-800/20" },
  { fill: "bg-green-100 text-green-800",     ring: "after:border-green-800/20" },
  { fill: "bg-emerald-100 text-emerald-800", ring: "after:border-emerald-800/20" },
  { fill: "bg-teal-100 text-teal-800",       ring: "after:border-teal-800/20" },
  { fill: "bg-cyan-100 text-cyan-800",       ring: "after:border-cyan-800/20" },
  { fill: "bg-sky-100 text-sky-800",         ring: "after:border-sky-800/20" },
  { fill: "bg-blue-100 text-blue-800",       ring: "after:border-blue-800/20" },
  { fill: "bg-indigo-100 text-indigo-800",   ring: "after:border-indigo-800/20" },
  { fill: "bg-violet-100 text-violet-800",   ring: "after:border-violet-800/20" },
  { fill: "bg-purple-100 text-purple-800",   ring: "after:border-purple-800/20" },
  { fill: "bg-fuchsia-100 text-fuchsia-800", ring: "after:border-fuchsia-800/20" },
  { fill: "bg-pink-100 text-pink-700",       ring: "after:border-pink-700/20" },
  { fill: "bg-rose-100 text-rose-700",       ring: "after:border-rose-700/20" },
  { fill: "bg-slate-200 text-slate-700",     ring: "after:border-slate-700/20" },
  { fill: "bg-zinc-200 text-zinc-700",       ring: "after:border-zinc-700/20" },
  { fill: "bg-stone-200 text-stone-700",     ring: "after:border-stone-700/20" },
]

function hash(value) {
  const s = String(value ?? "")
  let h = 0
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0
  }
  return h
}

export function avatarColor(id) {
  return PALETTE[hash(id) % PALETTE.length]
}

// Returns one of 16 stock placeholder avatar images hosted on the
// TM2 CDN, keyed deterministically by id. Mirrors the legacy
// ProfilePicture convention so the same user always gets the same image.
export function placeholderUrlFor(id) {
  const n = typeof id === "number" ? Math.abs(id) : hash(id)
  const index = n % 16
  const slot = index === 0 ? 1 : index
  return `https://tm2-assets.ams3.cdn.digitaloceanspaces.com/images/shared/${slot}.png`
}
